<template>
    <div>
        <div class="header">Informations Déclarative</div>

        <v-form>
            <v-row>
                <v-col cols="6">
                    <v-card outlined class="card">
                        <v-card-title> TVA </v-card-title>
                        <v-card-actions>
                            <v-row>
                                <v-col cols="12">
                                    <v-select-filled
                                        v-model="declaration.vatSystem"
                                        outlined
                                        hide-details
                                        label="Régime TVA"
                                        :items="vatSystems"
                                        item-value="id"
                                        required
                                        density="compact"
                                        :item-title="(item) => item.name"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-select-filled
                                        v-model="declaration.vatDeclarationDay"
                                        outlined
                                        hide-details
                                        label="Jour déclaration TVA"
                                        :items="vatDeclarationDays"
                                        required
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-select-filled
                                        v-model="declaration.vatOption"
                                        outlined
                                        hide-details
                                        label="Option de TVA"
                                        :items="vatOptions"
                                        item-value="id"
                                        required
                                        density="compact"
                                        :item-title="(item) => item.name"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="6">
                    <v-card outlined class="card">
                        <v-card-title> Imposition </v-card-title>
                        <v-card-actions>
                            <v-row>
                                <v-col cols="12">
                                    <v-select-filled
                                        v-model="declaration.taxSystemType"
                                        outlined
                                        hide-details
                                        label="Régime fiscal"
                                        :items="taxSystemTypes"
                                        item-value="id"
                                        required
                                        density="compact"
                                        :item-title="(item) => item.name"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete-filled
                                        v-model="declaration.sie"
                                        :items="sieList"
                                        outlined
                                        density="compact"
                                        hide-details
                                        :item-title="
                                            (x) => {
                                                return (
                                                    x.city +
                                                    ' - ' +
                                                    x.name +
                                                    ' ' +
                                                    x.postalCode +
                                                    ' ' +
                                                    x.address
                                                );
                                            }
                                        "
                                        item-value="id"
                                        label="Service des impôts des entreprises"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <oss-date-picker-filled
                                        v-model="declaration.startBusinessDate"
                                        outlined
                                        dense
                                        hide-details
                                        label="Date de début d'activité"
                                        style="flex: 1"
                                        :textFieldReadOnly="false"
                                    >
                                    </oss-date-picker-filled>
                                </v-col>
                                <v-col cols="6">
                                    <oss-date-picker-filled
                                        v-model="declaration.firstAccountingPeriodEnd"
                                        outlined
                                        hide-details
                                        dense
                                        label="Date de fin du premier exercice"
                                        style="flex: 1"
                                        :textFieldReadOnly="false"
                                    >
                                    </oss-date-picker-filled>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script lang="ts">
import _, { orderBy } from "lodash";

import SIE_LIST from "@/graphql/company/SieList.gql";
import { CompanyVatSystem, getVATSystem } from "@/services/vat/vatHelpers.services";
import { FormSelectOption } from "@/types/formSelectOption.types";
import { declarationInfo } from "@/types/registerServices.types";
import { Component, Model, Vue, toNative } from "vue-facing-decorator";

@Component
export class DeclarationForm extends Vue {
    @Model({ default: null }) readonly declaration: declarationInfo;

    sieList: any = [];

    vatSystems: Array<FormSelectOption> = [
        { id: CompanyVatSystem.NotSubjectTo, name: getVATSystem(CompanyVatSystem.NotSubjectTo) },
        {
            id: CompanyVatSystem.BelowTheThreshold,
            name: getVATSystem(CompanyVatSystem.BelowTheThreshold),
        },
        { id: CompanyVatSystem.Normal, name: getVATSystem(CompanyVatSystem.Normal) },
        { id: CompanyVatSystem.Quartely, name: getVATSystem(CompanyVatSystem.Quartely) },
        { id: CompanyVatSystem.Simplified, name: getVATSystem(CompanyVatSystem.Simplified) },
        {
            id: CompanyVatSystem.SimplifiedExercise,
            name: getVATSystem(CompanyVatSystem.SimplifiedExercise),
        },
        {
            id: CompanyVatSystem.FlatRateRefund,
            name: getVATSystem(CompanyVatSystem.FlatRateRefund),
        },
    ];

    vatOptions: any = [
        { id: null, name: "N/C" },
        { id: "Debits", name: "Débits" },
        { id: "Receipts", name: "Encaissements" },
    ];

    vatDeclarationDays = [15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

    taxSystemTypes: any = [
        { id: "IS", name: "Impôts sur les Sociétés" },
        { id: "IR", name: "Impôts sur les Revenus" },
    ];

    async beforeMount() {
        const result = await this.$apollo.query({
            query: SIE_LIST,
        });
        this.sieList = orderBy(_.cloneDeep(result.data.getSie.sie), "postalCode");
    }
}

export default toNative(DeclarationForm);
</script>

<style scoped>
.header {
    text-align: center;
    margin-bottom: 2vh;
    font-weight: bold;
}

.card {
    border-width: 0px;
}
</style>
